module.exports = __webpack_public_path__ + "static/subscribe-bg-0a871e3456161b0b4b3a0646c0fe42dd.png";